import { Stack, Typography, Paper } from '@mui/material';
import { Box } from '@mui/system';
import { ResultRow } from '../../../pages/Ems/Components/ResultRow';

export function NeglectAssessment({ testDetails }) {
  const formattedValue = () => {
    if (!Number.isInteger(testDetails?.starsCounted) || !Number.isInteger(testDetails?.starsDisplayed)) {
      return 'Cannot determine';
    }
    return testDetails?.starsCounted === testDetails?.starsDisplayed ? 'NO' : 'YES';
  };

  return (
    <>
      <Stack>
        <Paper sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '8px' }}>
                <ResultRow title="Neglect Detected" value={formattedValue()} />
                {testDetails?.starsCounted && (
                <Typography variant="h6" color="textPrimary" component="h6">
                    <strong>Stars counted:</strong> {testDetails?.starsCounted}
                </Typography>
                )}
                {testDetails?.starsDisplayed && (
                <Typography variant="h6" color="textPrimary" component="h6">
                    <strong>Stars displayed:</strong> {testDetails?.starsDisplayed}
                </Typography>
                )}
            </Box>
        </Paper>
      </Stack>
    </>
  );
}
